import { useTranslation } from 'react-i18next';

export const useTranslatedValue = () => {
    const { t } = useTranslation();

    const translatedValue = (txKeyPath: string, params?: { [key: string]: unknown }) => {
        return t(txKeyPath, params);
    };

    return translatedValue;
};
